module.exports = __webpack_public_path__ + "static/img/name4.01bb2a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/name4.png
// module id = JoFo
// module chunks = 1